<template>
  <transition name="dialog-fade">
    <div class="whaty-dialog__wrapper" v-show="visible" @click.self="handleWrapperClick">
      <div
        class="el-dialog whaty-dialog"
        :class="[{ 'is-fullscreen': fullscreen, 'el-dialog--center': center }, customClass]"
        ref="dialog"
        :style="style">

        <div class="popup-head">
          <slot name="title">
            <span class="popup-tit">{{ title || '&nbsp;' }}</span>
          </slot>
          <a v-if="showClose"
             @click="handleClose"
             href="javascript:" class="btn btn-shut popup-shut"><i class="mng icon-cross-stroke"></i></a>
        </div>

        <div v-if="$slots.body">
          <slot name="body"></slot>
        </div>
        <div class="popup-body" v-if="!$slots.body">
          <div class="popup-content popup-content-simple" v-if="rendered">
            <slot></slot>
          </div>
          <div class="popup-foot" v-if="!$slots.footer">
            <a @click="handleYesBtn" href="javascript:" class="btn btn-solid">确定</a>
            <a v-if="showClose" @click="handleClose" href="javascript:" class="btn btn-hollow">取消</a>
          </div>
          <div class="popup-foot" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import Popup from 'element-ui/src/utils/popup'
  import emitter from 'element-ui/src/mixins/emitter'

  export default {
    name: 'whaty-dialog',
    mixins: [Popup, emitter],
    props: {
      title: {
        type: String,
        default: ''
      },
      modal: {
        type: Boolean,
        default: true
      },
      modalAppendToBody: {
        type: Boolean,
        default: true
      },
      appendToBody: {
        type: Boolean,
        default: false
      },
      lockScroll: {
        type: Boolean,
        default: true
      },
      closeOnClickModal: {
        type: Boolean,
        default: true
      },
      closeOnPressEscape: {
        type: Boolean,
        default: true
      },
      showClose: {
        type: Boolean,
        default: true
      },
      width: String,
      fullscreen: Boolean,
      customClass: {
        type: String,
        default: ''
      },
      top: {
        type: String,
        default: '15vh'
      },
      beforeClose: Function,
      center: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        closed: false
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.closed = false
          this.$emit('open')
          this.$el.addEventListener('scroll', this.updatePopper)
          this.$nextTick(() => {
            this.$refs.dialog.scrollTop = 0
          })
          if (this.appendToBody) {
            document.body.appendChild(this.$el)
          }
        } else {
          this.$el.removeEventListener('scroll', this.updatePopper)
          if (!this.closed) this.$emit('close')
        }
      }
    },

    computed: {
      style() {
        let style = {}
        if (this.width) {
          style.width = this.width
        }
        if (!this.fullscreen) {
          style.marginTop = this.top
        }
        return style
      }
    },

    methods: {
      handleWrapperClick() {
        if (!this.closeOnClickModal) return
        this.handleClose()
      },
      handleYesBtn() {
        this.$emit('yes-btn-click')
      },
      handleClose() {
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.hide)
        } else {
          this.hide()
        }
      },
      hide(cancel) {
        if (cancel !== false) {
          this.$emit('update:visible', false)
          this.$emit('close')
          this.closed = true
        }
      },
      updatePopper() {
        this.broadcast('ElSelectDropdown', 'updatePopper')
        this.broadcast('ElDropdownMenu', 'updatePopper')
      }
    },

    mounted() {
      if (this.visible) {
        this.rendered = true
        this.open()
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dialog/dialog.vue